import { statusInfo } from "@/constants/statuses";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Phone } from "lucide-react";

export default function MeterTable({ meters }) {
  return (
    <div className="p-4 lg:p-6" data-testid="meter-table-view">
      <div className="mb-4">
        <h2 className="font-display text-xl font-bold">Tableau des compteurs</h2>
        <p className="text-sm text-slate-500">{meters.length} lignes</p>
      </div>

      <div className="rounded-lg border border-slate-800 overflow-hidden">
        <div className="max-h-[calc(100vh-220px)] overflow-auto">
          <Table>
            <TableHeader className="sticky top-0 bg-slate-900 z-10">
              <TableRow className="border-slate-800 hover:bg-transparent">
                <TableHead>Statut</TableHead>
                <TableHead>Nom</TableHead>
                <TableHead>Adresse</TableHead>
                <TableHead>NPA / Lieu</TableHead>
                <TableHead>ID</TableHead>
                <TableHead>Téléphone</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {meters.map((m) => {
                const info = statusInfo(m.statut);
                return (
                  <TableRow key={m.id} className="border-slate-800" data-testid="table-row">
                    <TableCell>
                      <span className={`text-[10px] px-2 py-0.5 rounded-full border ${info.chip} whitespace-nowrap`}>
                        {info.short}
                      </span>
                    </TableCell>
                    <TableCell className="font-medium">{m.nom_famille || "—"}</TableCell>
                    <TableCell className="text-slate-300">{[m.rue, m.numero].filter(Boolean).join(" ") || "—"}</TableCell>
                    <TableCell className="text-slate-400">{m.code_postal} {m.lieu}</TableCell>
                    <TableCell className="font-mono-data text-xs text-slate-400">{m.ref || m.numero_serie || "—"}</TableCell>
                    <TableCell className="text-slate-300 text-xs">
                      {m.telephone ? (
                        <a href={`tel:${m.telephone}`} className="hover:text-[#00A896] flex items-center gap-1">
                          <Phone className="h-3 w-3" />
                          {m.telephone}
                        </a>
                      ) : (
                        "—"
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
